import unitContainer from './UnitContainer.directive';

unitPopupRoutesConfig.$inject = ['$stateProvider'];

export function unitPopupRoutesConfig($stateProvider) {
  $stateProvider
    .state('unitpopup', {
      url: '/unitpopup',
      template: `<div ${unitContainer.htmlName}></div><ui-view/>`,
    })
    .state('unitpopup.view', {
      url: '/view/:id',
    });
}
